import Icon from 'components/shared/Icon/Icon';
import Modal from 'components/shared/Modal/Modal';

const PhoneSupportModal = ({ isOpen, onClose }) => {
  return (
    <Modal
      handleOpen={isOpen}
      handleClose={onClose}
      slideFromRight={false}
      className="!w-[576px] max-w-full"
      title="Contact Myriad support">
      <div>
        <ul className="flex flex-col gap-6">
          <li className="flex gap-2">
            <div className="w-fit rounded-lg bg-primary-25 p-1">
              <Icon color="primary" icon="call-calling-mono" size={24} />
            </div>
            <div>
              <p className="text-sm font-500 text-neutral-900">Phone number</p>
              <a href="tel:+19144317335" className="text-xs text-neutral-900 hover:underline">
                (914) 431-7335
              </a>
            </div>
          </li>
          <li className="flex gap-2">
            <div className="w-fit rounded-lg bg-primary-25 p-1">
              <Icon color="primary" icon="mail-mono" size={24} />
            </div>
            <div>
              <p className="text-sm font-500 text-neutral-900">Email</p>
              <a
                href="mailto:onboarding@myriadsystems.ai"
                className="text-xs text-neutral-900 hover:underline">
                onboarding@myriadsystems.ai
              </a>
            </div>
          </li>
        </ul>
      </div>
    </Modal>
  );
};

export default PhoneSupportModal;
